;(function (angular, _, UUID) {
  'use strict'

  angular
    .module('kilo.routes.order.show')
    .controller('AddRubricController', AddRubricController)

  AddRubricController.$inject = [
    // Angular
    '$uibModalInstance',

    // Libs

    // Managers
    'RubricManager',

    // Services
    'RubricService',

    // Const

    // Resolved
    'order', 'rubrics'

  ]

  function AddRubricController (
    // Angular
    $uibModalInstance,

    // Libs

    // Managers
    RubricManager,

    // Services
    RubricService,

    // Const

    // Resolved
    order, rubrics

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        rubrics: rubrics,
        newRubric: {},
        // Public Method
        getMaxPosition: getMaxPosition,
        addRubric: addRubric,
        selectParent: selectParent,
        unselectParent: unselectParent,
        deleteAll: deleteAll,
        getPositionLabel: getPositionLabel,
        deleteRubric: deleteRubric,
        accept: accept,
        cancel: cancel
      })

      init()
    }

    function init () {
      self.rubrics = self.rubrics || []
      self.sortedRubrics = []
      self.sortedRubrics = _.flattenDeep(RubricService.sortRubrics(self.rubrics))
      self.newRubric = RubricManager.create({
        position: getMaxPosition() + 1 || 1,
        label: ''
      })
      if (self.newRubric.parent || self.selectedParent) {
        delete self.newRubric.parent
        delete self.selectedParent
      }
    }

    function reindexChildren (arr) {
      var i = 1
      _.each(arr, function (elt) {
        var children = _.filter(self.rubrics, function (r) {
          if (typeof r.parent === 'object') return r.parent._id === elt._id
          return r.parent === elt._id
        })
        if (children && children.length) reindexChildren(children)
        elt.position = i
        i++
      })
    }

    function reindex () {
      var i = 1
      _.each(self.rubrics, function (elt) {
        if (!elt.parent) {
          var children = _.filter(self.rubrics, function (r) {
            if (typeof r.parent === 'object') return r.parent._id === elt._id
            return r.parent === elt._id
          })
          if (children && children.length) reindexChildren(children)
          elt.position = i
          i++
        }
      })
      self.sortedRubrics = []
      init()
    }

    function getParentMaxPosition (parent) {
      return RubricService.getParentMaxPosition(parent, self.rubrics)
    }

    function getMaxPosition () {
      return RubricService.getMaxPosition(self.rubrics)
    }

    function getPositionLabel (elt) {
      return RubricService.getPositionLabel(elt, self.sortedRubrics)
    }

    function unselectParent () {
      delete self.newRubric.parent
      delete self.selectedParent
      self.newRubric.position = getMaxPosition() + 1 || 1
    }

    function selectParent (parent) {
      self.newRubric.parent = parent._id
      self.newRubric.position = getParentMaxPosition(parent) + 1 || 1
      self.selectedParent = '' + getPositionLabel(parent) + ' - ' + parent.label
    }

    function addRubric () {
      self.newRubric._id = UUID.genV4().toString()
      self.rubrics.push(angular.copy(self.newRubric))
      init()
    }

    function deleteRubric (rubric) {
      var toRemove = _.map(_.flattenDeep(RubricService.getChildren(rubric, angular.copy(self.rubrics))), function (elt) {
        return elt._id
      }) || []
      toRemove.push(rubric._id)
      _.remove(self.rubrics, function (elt) {
        return _.includes(toRemove, elt._id)
      })
      reindex()
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function deleteAll () {
      self.rubrics = []
      init()
    }

    function accept () {
      $uibModalInstance.close(self.sortedRubrics)
    }
  }
})(window.angular, window._, window.UUID)
